import { get_headers, GET_APPLICATION_DOCUMENTS, GET_ENTITY_COMPLIANCE_OVERVIEW_URL
} from '@/utils/constants/constants';
import alert_mixin from "@/utils/mixins/alert_mixin";
import axios from 'axios';
import FilePreviewComponent from "@/components/probaworkflows_base_components/FilePreviewComponent/FilePreviewComponent.vue";

export default {
  name: 'DashboardView',
  mixins: [alert_mixin],
  components: { FilePreviewComponent },

  data: () => ({
    entity_profile_id: Number(sessionStorage.getItem('entity_profile_id')) || null,
    entity_name: sessionStorage.getItem('entity_name'),
    hero_title: "BEE Trust",
    hero_description: "Management Portal",

    stats_cards: [
      {
        label: "Pending KYC Reviews",
        value: "5",
        subtext: "2 urgent",
        icon: "fas fa-clipboard-check",
        colorClass: "icon-yellow"
      },
      {
        label: "Upcoming Meetings",
        value: "3",
        subtext: "Next: 28 Jan",
        icon: "fas fa-calendar-alt",
        colorClass: "icon-blue"
      },
      {
        label: "Resolution Pending",
        value: "2",
        subtext: "Acknowledgement required",
        icon: "fas fa-exclamation-triangle",
        colorClass: "icon-orange"
      },
      {
        label: "Compliance Score",
        value: "0%",
        subtext: "Loading...",
        icon: "fas fa-shield-alt",
        colorClass: "icon-green"
      }
    ],
    // 3. GlobalTable Data (Recent Documents)
    table_headers: [
      { label: "Document Name", key: "name" },
      { label: "Category", key: "category" },
      { label: "Date", key: "date" },
      { label: "Actions", key: "actions" }
    ],
    table_safe_company_list: [],
    recent_documents_loading: false,
    show_file_preview: false,
    preview_file_url: '',
    preview_file_name: '',
    // 4. Upcoming Meetings Data
    meetings: [
      { id: 1, tag: "Trustee Meeting", title: "Q1 Trustee Review Meeting", date: "28 Jan 2025", time: "10:00 AM" },
      { id: 2, tag: "Annual General Meeting", title: "Annual General Meeting", date: "15 Feb 2025", time: "10:00 AM" },
      { id: 3, tag: "Special Meeting", title: "Special Resolution - Amendment", date: "22 Feb 2025", time: "10:00 AM" }
    ],
    // 5. Action Center Data
    actions: [
      { id: 1, title: "Review KYC: Thandi Ngcobo", type: "KYC", statusColor: "dot-orange" },
      { id: 2, title: "Acknowledge Resolution #2024-15", type: "Resolution", statusColor: "dot-green" },
      { id: 3, title: "RSVP: Q1 Trustee Meeting", type: "Meeting", statusColor: "dot-green" },
      { id: 4, title: "Review KYC: Bongani Zulu", type: "KYC", statusColor: "dot-orange" }
    ],

    is_loading_tasks: false,
    tasks: [],
    more_unanswered_count: 0,
    // 6. Distribution Data (For reference if you want to make it dynamic)
    distribution_stats: null,
  }),



  computed: {
    is_super_user() {
      return this.$store.state.user.is_superuser;
    }
  },

  mounted() {
    this.distribution_stats = {
      ytd_total: "R 7 050 000",
      growth: "+12.5%",
      next_amount: "R 2 600 000",
      next_date: "15 Mar 2025"
    };
    this.fetch_recent_documents();
    this.load_compliance_tasks();
  },

  methods: {
    get_doc_color_class(category) {
      const map = {
        'Legal': 'bg-red-light',
        'Governance': 'bg-gray-light',
        'Verification': 'bg-orange-light',
        'Financial': 'bg-green-light'
      };
      return Reflect.get(map, category) || 'bg-gray-light';
    },

    deactivate_company() {
      if (confirm("Are you sure you want to deactivate this client?")) {
        // Your logic here
      }
    },

    fetch_recent_documents() {
      const application_id = sessionStorage.getItem('application_id');
      if (!application_id) return;

      this.recent_documents_loading = true;

      axios.get(GET_APPLICATION_DOCUMENTS, {
        headers: get_headers(),
        params: { application_id },
      })
      .then((response) => {
        const docs = response.data?.data || [];
        this.table_safe_company_list = docs
          .sort((a, b) => new Date(b.submitted_on) - new Date(a.submitted_on))
          .slice(0, 3)
          .map((doc, index) => ({
            id: doc.section_question_id || index + 1,
            name: doc.file_name,
            category: doc.section || 'General',
            date: new Date(doc.submitted_on).toLocaleDateString(),
            icon: 'far fa-file-pdf',
            presigned_url: doc.presigned_url,
          }));
      })
      .catch((error) => {
        this.show_error('Error loading recent documents: ' + (error.response?.data?.message || error.message));
      })
      .finally(() => {
        this.recent_documents_loading = false;
      });
    },

    view_all_documents() {
      sessionStorage.setItem('active_tab', 'Documents');
      sessionStorage.setItem('active_master_tab', 'documents');
      sessionStorage.setItem('came_from_dashboard', 'trustee');

      this.$router.push({
        path: '/entity_application_overview',
        query: {
          application_id: sessionStorage.getItem('application_id'),
          entity_profile_id: sessionStorage.getItem('entity_profile_id'),
          entity_type_id: sessionStorage.getItem('entity_type_id'),
        }
      });
    },

    open_file_preview(doc) {
      this.preview_file_url = doc.presigned_url;
      this.preview_file_name = doc.name;
      this.show_file_preview = true;
    },

    close_file_preview() {
      this.show_file_preview = false;
      this.preview_file_url = '';
      this.preview_file_name = '';
    },

    async load_compliance_tasks() {
      if (!this.entity_profile_id) {
          console.warn('entity_profile_id is missing from sessionStorage');
          return;
      }
      this.is_loading_tasks = true;
      this.tasks = [];
      this.more_unanswered_count = 0;

      try {
        const response = await axios.get(GET_ENTITY_COMPLIANCE_OVERVIEW_URL, {
          params: { entity_profile_id: this.entity_profile_id },
          headers: get_headers(),
        });

        if (response.data.status === 'success') {
          const overview_data = response.data.data;
          const actionable_items = overview_data.actionable_items || [];

          this.tasks = actionable_items.map(doc => this.format_task(doc)).slice(0, 3);
          this.more_unanswered_count = Math.max(0, actionable_items.length - 3);

          this.calculate_stats(overview_data, actionable_items);
        }
      } catch (error) {
        console.warn('Error loading compliance tasks:', error);
        this.tasks = [];
      } finally {
        this.is_loading_tasks = false;
      }
    },

    calculate_stats(overview_data) {
      const rules = overview_data.rules || [];
      const compliant_count = rules.filter(r => r.answered_count === r.total_questions).length;
      const compliance_rate = rules.length > 0
        ? Math.round((compliant_count / rules.length) * 100)
        : 0;

      // Update compliance card in stats_cards array
      const compliance_card = this.stats_cards.find(s => s.label === 'Compliance Score');
      if (compliance_card) {
        compliance_card.value = `${compliance_rate}%`;
        compliance_card.subtext = compliance_rate >= 80
          ? 'Excellent standing'
          : compliance_rate >= 50
          ? 'Needs attention'
          : 'Action required';
        compliance_card.colorClass = compliance_rate >= 80
          ? 'icon-green'
          : compliance_rate >= 50
          ? 'icon-yellow'
          : 'icon-red';
      }
    },

    format_task(doc) {
      return {
        id: doc.compliance_field_id,
        compliance_field_id: doc.compliance_field_id,
        priority: doc.priority || 'orange',
        title: doc.title,
        description: doc.description,
        deadline: doc.deadline || 'Awaiting response',
        deadlineClass: doc.priority === 'red' ? 'tag-red' : 'tag-orange',
        tags: [doc.rule_name || 'Compliance'],
        btnText: 'Answer Question',
        btnClass: doc.priority === 'red' ? 'btn-success' : 'btn-outline-secondary',
      };
    },
  },
};